import React from 'react';

interface InputProps {
  type?: 'text' | 'email' | 'password' | 'textarea' | 'checkbox' | 'select';
  placeholder?: string;
  name?: string;
  value?: string | boolean;
  onChange?: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => void;
  label?: string;
  required?: boolean;
  options?: string[];
}

const Input: React.FC<InputProps> = ({ type = 'text', placeholder = '', name = '', value, onChange, label = '', required = false, options = [] }) => {
  const id = name + '_' + Math.random().toString(36).substring(7);

  return (
    <div className={type === 'checkbox' ? '' : 'input_label_container'}>
      {label && type !== 'checkbox' && <label className='input_label' htmlFor={id}>{label}</label>}
      <div className={type === 'checkbox' ? '' : 'input_container'}>
        {type === 'textarea' ? (
          <textarea
            className='input_field'
            placeholder={placeholder}
            name={name}
            value={value as string}
            onChange={onChange}
            required={required}
            id={id}
          />
        ) : type === 'select' ? (
          <select
            className='input_field'
            name={name}
            value={value as string}
            onChange={onChange}
            required={required}
            id={id}
          >
            {options.map((option, index) => (
              <option key={index} value={option}>
                {option}
              </option>
            ))}
          </select>
        ) : type === 'checkbox' ? (
          <div className='checkbox_container'>
            <label htmlFor={id}>{label}</label>
            <input
              className='checkbox_input'
              type='checkbox'
              name={name}
              checked={value as boolean}
              onChange={onChange}
              required={required}
              id={id}
            />
          </div>
        ) : (
          <input
            className='input_field'
            type={type}
            placeholder={placeholder}
            name={name}
            value={value as string}
            onChange={onChange}
            required={required}
            id={id}
          />
        )}
      </div>
    </div>
  );
};

export default Input;
